import {
  PopoverArrow,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  useDisclosure,
} from "@chakra-ui/react";
import ProfileMenu from "./ProfileMenu";
import UserPickerModal from "./UserPickerModal";

const ProfilePopover: React.FC<{
  isOpenState: [boolean, React.Dispatch<React.SetStateAction<boolean>>];
}> = ({ isOpenState: [, setIsOpen] }) => {
  const userPickerState = useDisclosure();

  return (
    <>
      <UserPickerModal {...userPickerState} />
      <PopoverContent>
        <PopoverArrow />
        <PopoverCloseButton />
        <PopoverBody>
          <ProfileMenu
            close={() => setIsOpen(false)}
            openSwitchAccountModal={userPickerState.onOpen}
          />
        </PopoverBody>
      </PopoverContent>
    </>
  );
};

export default ProfilePopover;
